<template>
  <zl-saas-container>
    <!-- 操作记录 -->
    <operRecord :id="$route.query.id"  v-if="!$route.query.approval"/>
    <!-- 订单基本信息 -->
    <orderInfo
      :basicInfo="basicInfo"
      :secondInfo="secondInfo"
      @success="signSuccess"
    />
    <template v-if="$route.query.type !== 'pay'">
      <!-- 货物清单、服务清单 -->
      <orderList
        v-if="columnString"
        :key="orderListKey"
        :orderType="basicInfo.orderType"
        :secondInfo="secondInfo"
        :columnString="columnString"
      />
      <!-- 收货信息 -->
      <consigneeInfo
        v-if="secondInfo && secondInfo.consignee"
        :secondInfo="secondInfo"
      />
      <!-- 子订单信息 -->
      <childOrderList />
      <!-- 付款记录 -->
      <payReocrd :currencyCH="basicInfo.currencyCH"/>
      <!-- 开票记录 -->
      <invoiceInfoRecord />

      <!-- 审批插槽 -->
      <slot></slot>
      <template slot="footer">
        <slot name="footer"/>
      </template>
    </template>
    <template v-else>
      <!-- 付款信息汇总 -->
      <el-card class="m-b">
        <div slot="header" class="clearfix">
          <span class="saas-card-header-name">付款信息汇总</span>
        </div>
        <div class="order-content-detail">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="common-item-money">
                <span>订单预算金额（元）：</span>
                <span>{{_util.formatMoney(secondInfo.budgetAmount)}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="common-item-money">
                <span>验收总金额（元）：</span>
                <span>{{_util.formatMoney(shTotalMoney)}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="common-item-money">
                <span>已付款总金额（元）：</span>
                <span>{{_util.formatMoney(realTotalMoney)}}</span>
              </div>
            </el-col>
          </el-row>
        </div>

      </el-card>
      <!-- 付款记录 -->
      <payReocrd :currencyCH="basicInfo.currencyCH"/>
    </template>
  </zl-saas-container>
</template>
<script>

import dayjs from 'dayjs'
import { getValue } from '@/lib/enum'
import orderInfo from '@/components/order/detail/orderInfo.vue'
import invoiceInfoRecord from '@/components/order/detail/invoiceInfoRecord.vue'
import payReocrd from '@/components/order/detail/payReocrd.vue'
import consigneeInfo from '@/components/order/detail/consigneeInfo.vue'
import operRecord from '@/components/business/operRecord.vue'
import childOrderList from '@/components/order/detail/childOrderList.vue'
import orderList from '@/components/order/detail/orderList.vue'
import { mapActions } from 'vuex'
export default {
  name: 'OrderCheck',
  components: {
    orderList,
    childOrderList,
    payReocrd,
    orderInfo,
    operRecord,
    consigneeInfo,
    invoiceInfoRecord
  },
  data() {
    return {
      dayjs,
      getValue,
      columnString: '', // 清单表头
      basicInfo: {}, // 基本信息
      secondInfo: {}, // 第二步信息
      payTypeList: [
        {
          id: 1,
          name: '预付款',
          value: ''
        },
        {
          id: 2,
          name: '发货款',
          value: ''
        },
        {
          id: 3,
          name: '到货款',
          value: ''
        },
        {
          id: 4,
          name: '安装/调试款',
          value: ''
        },
        {
          id: 5,
          name: '质保金/质保函',
          value: ''
        },
        {
          id: 6,
          name: '其他',
          value: ''
        }
      ],
      orderListKey: 0,
      realTotalMoney: 0, // 已付款总金额
      shTotalMoney: 0, // 已验收总金额
      isSubmitData: false // 当前页面是否是待提交的数据
    }
  },
  activated() {
    this.initData()
  },
  created() {
    // this.initData()
  },
  methods: {
    ...mapActions([
      'getFirstOrderStep',
      'getFirstOrderStepZS',
      'getSecondOrderStepZS',
      'getSecondOrderStep',
      'getDdColumnZS',
      'getDdColumnBj',
      'getCountTotalMoney'
    ]),
    initData() {
      if (this.$route.query.status === undefined) {
        this.isSubmitData = true
      } else {
        this.isSubmitData = this.$route.query.status && Number(this.$route.query.status) <= 1003
      }
      if (this.$route.query.id) {
        this.getDetail()
      }
    },
    async getDetail() {
      // if (this.$route.query.type === 'pay') {
      //   this.$changeRouteName('付款')
      // } else {
      //   this.$changeRouteName('查看订单')
      // }
      // 获取第一步基本信息   待提交的订单数据  还没存进数据库  所以不是调用正式接口
      await this[`${this.isSubmitData ? 'getFirstOrderStep' : 'getFirstOrderStepZS'}`]({
        id: this.$route.query.id
      }).then(async res => {
        if (res.percent) {
          let percent = res.percent.split('|')
          this.payTypeList.map((item, index) => {
            item.value = percent[index] !== '0' ? percent[index] : ''
            // 如果是其他付款方式，则显示自定义付款方式名称
            if (res.othenName && item.id === 6) {
              item.name = res.othenName
            }
          })
        }
        this.basicInfo = {
          ...res
        }
        this.basicInfo.orderType = this.basicInfo.orderType.toString()
        this.basicInfo.purchaseType = this.basicInfo.purchaseType.toString()
        if (this.payTypeList.some(val => val.value)) {
          this.basicInfo.payTypeList = [...this.payTypeList.filter(val => val.value)]
        }
        if (this.basicInfo.certFileId) {
          const fileList = await this._util.getFileInfo(this.basicInfo.certFileId)
          this.$set(this.basicInfo, 'fileList', fileList)
        }
      })
      // 获取第二步信息
      await this[`${this.isSubmitData ? 'getSecondOrderStep' : 'getSecondOrderStepZS'}`]({
        id: this.$route.query.id
      }).then(res => {
        this.secondInfo = res
      })
      if (this.$route.query.type === 'pay') {
        // 查询主订单已收货总金额，已付款总金额
        await this.getCountTotalMoney({
          orderId: this.$route.query.id
        }).then(res => {
        // 已付款总金额
          this.realTotalMoney = res.realTotalMoney
          // 已验收总金额
          this.shTotalMoney = res.shTotalMoney
        })
      } else {
        this.getDdColumn()
      }
    },
    // 获取订单清单表头
    async getDdColumn() {
      // 待提交的订单数据  还没存进数据库  所以不是调用正式接口
      await this[`${this.isSubmitData ? 'getDdColumnBj' : 'getDdColumnZS'}`]({
        unionId: this.$route.query.id
      }).then(res => {
        // 初始表头
        const listColumns = JSON.parse(res.colValue || '[]')
        if (listColumns.length) {
          // 在最新的表头后面添加‘到货数量’，‘验收数量’，‘退货数量’，‘换货数量’
          const length = listColumns.length
          const deliverSize = {
            columnNameCH: '累计发货数量',
            columnNameEN: 'deliverSize',
            seq: length
          }
          const arrivalSize = {
            columnNameCH: '累计到货数量',
            columnNameEN: 'arrivalSize',
            seq: length + 1
          }
          const checkSize = {
            columnNameCH: '累计验收数量',
            columnNameEN: 'checkSize',
            seq: length + 2
          }
          const returnSize = {
            columnNameCH: '累计退货数量',
            columnNameEN: 'returnSize',
            seq: length + 3
          }
          const barterSize = {
            columnNameCH: '累计换货数量',
            columnNameEN: 'barterSize',
            seq: length + 4
          }
          listColumns.push(deliverSize, arrivalSize, checkSize, returnSize, barterSize)

          this.columnString = JSON.stringify(listColumns)
          this.orderListKey++
        }
      })
    },
    // 签章成功
    signSuccess() {
      this.init()
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/order.scss';
</style>
